import React from "react";

export default function KPICard({ label, value, hint, accent, testid }) {
  const accentColor =
    accent === "emerald"
      ? "text-emerald-600"
      : accent === "red"
      ? "text-red-600"
      : "text-neutral-950";

  return (
    <div
      className="bg-white p-4 md:p-8 transition-all duration-300 hover:-translate-y-[2px] hover:shadow-sm relative group"
      data-testid={testid}
    >
      <div className="font-mono-data text-[10px] md:text-[11px] uppercase tracking-[0.18em] md:tracking-[0.2em] text-neutral-500">
        {label}
      </div>
      <div
        className={`font-display text-3xl md:text-6xl tracking-tighter mt-2 md:mt-4 ${accentColor}`}
        data-testid={`${testid}-value`}
      >
        {value}
      </div>
      {hint && (
        <div className="font-mono-data text-[10px] md:text-[11px] uppercase tracking-[0.1em] md:tracking-[0.12em] text-neutral-500 mt-2 md:mt-3">
          {hint}
        </div>
      )}
      <div className="absolute top-0 right-0 w-2 h-2 bg-neutral-200 group-hover:bg-neutral-950 transition-colors" />
    </div>
  );
}
